"use client";

import { useTranslations } from "next-intl";

import { pageConfig } from "@/config/pages.config";
import { Link } from "@/i18n/routing";
import CookieIcon from "@/icons/ui/feedback/cookie.svg";
import { saveAgreeCookies } from "@/services/cookies/user-info.service";
import Button from "@/ui/Common/Button";

import styles from "./style.module.scss";

export const CookiesInfo = ({
  agreeCookies,
}: {
  agreeCookies: (val: string) => void;
}) => {
  const t = useTranslations();

  const handleClick = () => {
    agreeCookies("true");
    saveAgreeCookies("true");
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <CookieIcon className={styles.icon} />
        <p className={styles.title}>
          {t("The website uses")}
          <Link
            href={pageConfig.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.desc}
          >
            {` ${t("cookies")}`}
          </Link>
          .
        </p>
      </div>
      <Button
        className="h-[5.4rem]"
        onClick={handleClick}
      >
        {t("Agree")}
      </Button>
    </div>
  );
};
